import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

interface RemoveAllDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  onConfirm: () => void;
  isPending: boolean;
}

export function RemoveAllDialog({ open, onOpenChange, count, onConfirm, isPending }: RemoveAllDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[380px] bg-card">
        <DialogHeader>
          <DialogTitle>Remove All Subscriptions</DialogTitle>
          <DialogDescription>
            This will unsubscribe you from all {count} brand{count !== 1 ? "s" : ""}. You can re-add them at any time.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="rounded-lg"
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isPending}
            className="rounded-lg"
          >
            Remove All
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
